var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var resolveURL = require('resolve-url');

var blueimpLoadImage = require('blueimp-load-image');
/**
 * readFromBlobOrFile
 *
 * @name readFromBlobOrFile
 * @function
 * @access private
 */


var readFromBlobOrFile = function readFromBlobOrFile(blob) {
  return new Promise(function (resolve, reject) {
    var fileReader = new FileReader();

    fileReader.onload = function () {
      resolve(fileReader.result);
    };

    fileReader.onerror = function (_ref) {
      var code = _ref.target.error.code;
      reject(Error("File could not be read! Code=".concat(code)));
    };

    fileReader.readAsArrayBuffer(blob);
  });
};

var fixOrientationFromUrlOrBlobOrFile = function fixOrientationFromUrlOrBlobOrFile(blob) {
  return new Promise(function (resolve) {
    blueimpLoadImage(blob, function (img) {
      return img.toBlob(resolve);
    }, {
      orientation: true,
      canvas: true
    });
  });
};
/**
 * loadImage
 *
 * @name loadImage
 * @function load image from different source
 * @access private
 */


var loadImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(image) {
    var data, resp, img, _img;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = image;

            if (!(typeof image === 'undefined')) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", 'undefined');

          case 3:
            if (!(typeof image === 'string')) {
              _context2.next = 24;
              break;
            }

            if (!image.endsWith('.pbm')) {
              _context2.next = 13;
              break;
            }

            _context2.next = 7;
            return fetch(resolveURL(image));

          case 7:
            resp = _context2.sent;
            _context2.next = 10;
            return resp.arrayBuffer();

          case 10:
            data = _context2.sent;
            _context2.next = 22;
            break;

          case 13:
            img = image; // If not Base64 Image

            if (!/data:image\/([a-zA-Z]*);base64,([^"]*)/.test(image)) {
              img = resolveURL(image);
            }

            _context2.t0 = readFromBlobOrFile;
            _context2.next = 18;
            return fixOrientationFromUrlOrBlobOrFile(img);

          case 18:
            _context2.t1 = _context2.sent;
            _context2.next = 21;
            return (0, _context2.t0)(_context2.t1);

          case 21:
            data = _context2.sent;

          case 22:
            _context2.next = 47;
            break;

          case 24:
            if (!(image instanceof HTMLElement)) {
              _context2.next = 38;
              break;
            }

            if (!(image.tagName === 'IMG')) {
              _context2.next = 29;
              break;
            }

            _context2.next = 28;
            return loadImage(image.src);

          case 28:
            data = _context2.sent;

          case 29:
            if (!(image.tagName === 'VIDEO')) {
              _context2.next = 33;
              break;
            }

            _context2.next = 32;
            return loadImage(image.poster);

          case 32:
            data = _context2.sent;

          case 33:
            if (!(image.tagName === 'CANVAS')) {
              _context2.next = 36;
              break;
            }

            _context2.next = 36;
            return new Promise(function (resolve) {
              image.toBlob( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return readFromBlobOrFile(blob);

                        case 2:
                          data = _context.sent;
                          resolve();

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
            });

          case 36:
            _context2.next = 47;
            break;

          case 38:
            if (!(image instanceof File || image instanceof Blob)) {
              _context2.next = 47;
              break;
            }

            _img = image;

            if (image.name.endsWith('.pbm')) {
              _context2.next = 44;
              break;
            }

            _context2.next = 43;
            return fixOrientationFromUrlOrBlobOrFile(_img);

          case 43:
            _img = _context2.sent;

          case 44:
            _context2.next = 46;
            return readFromBlobOrFile(_img);

          case 46:
            data = _context2.sent;

          case 47:
            return _context2.abrupt("return", new Uint8Array(data));

          case 48:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadImage(_x) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = loadImage;